import React from "react";
import { Checkbox } from "antd";
import {
  ChantButton,
} from "../../../../../CommonComponents";
import ChantPopConfirm from "../../../../../CommonComponents/ChantTooltip/ChantPopConfirm";

const SubmitSection = ({
  acceptedTerms,
  notifyOnPublish,
  verifiedChange,
  checkChange,
  handleSubmit,
}) => {
  return (
    <>
      <div className="ct-terms-row">
        <Checkbox
          checked={acceptedTerms}
          onChange={verifiedChange}
          aria-label="Accepted terms checkbox"
        />
        <p className="ct-terms-text">
          <span style={{ color: "#ff4d4f", marginRight: 4 }}>*</span>
          I am authorized to create this ticket offer and understand it is
          between the group and our members. I understand and accept the{" "}
          <a href="https://www.chant.fan/terms" target="_blank" rel="noopener noreferrer">
            Chant terms
          </a>{" "}
          and transaction fee.
        </p>
      </div>

      <div className="ct-submit-row">
        <ChantPopConfirm
          placement="topRight"
          title={
            <div>
              <p>Submitting will post the tickets to Chant.</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <label>Send notification?</label>
                <Checkbox
                  checked={notifyOnPublish}
                  onChange={checkChange}
                  name="notifyOnPublish"
                  aria-label="Notify on publish checkbox"
                />
              </div>
            </div>
          }
          onConfirm={(e) => handleSubmit(e, "live")}
          onCancel={() => {}}
          okText="Ok"
          cancelText="Cancel"
        >
          <ChantButton>Publish</ChantButton>
        </ChantPopConfirm>

        <ChantButton
          type="secondary"
          onClick={(e) => handleSubmit(e, "saved")}
        >
          Save for Later
        </ChantButton>

        <ChantPopConfirm
          title="Are you sure? Will move to past tickets."
          onConfirm={(e) => handleSubmit(e, "archived")}
          onCancel={() => {}}
          okText="Ok"
          cancelText="Cancel"
        >
          <ChantButton type="secondary">Archive</ChantButton>
        </ChantPopConfirm>
      </div>
    </>
  );
};

export default SubmitSection;
